import PropTypes from 'prop-types'
import React from 'react'

import NotAvailableOnPlan from 'components/NotAvailableOnPlan'

import useArePoliciesAvailable from 'hooks/useArePoliciesAvailable'


export default function PoliciesRequired({ children }) {
  const arePoliciesAvailable = useArePoliciesAvailable()

  if ( arePoliciesAvailable ) {
    return children
  }

  return (
    <NotAvailableOnPlan />
  )
}

PoliciesRequired.propTypes = {
  children: PropTypes.node,
}
